import {
  ACTION_LOGIN,
  ACTION_UPDATE_PASSWORD,
  ACTION_GET_TERMS_CONDITIONS,
  ACTION_POST_TERMS_CONDITIONS,
  SET_USER,
  SET_TERMS_CONDITIONS
} from "@/views/login/store/types/types.js";

import {
  LoginService,
  PasswordService,
} from "../../../services";

import router from '@/router';
import EventBus from '@/utils/event_bus.js';
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

const actions = {
  [ACTION_LOGIN]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {

      const idGroup = sessionStorage.getItem("idGroup");
      const idEmpresa = sessionStorage.getItem("idEmpresa");
      const contrasenia = btoa(payload.contrasenia);
      const correo = payload.correo;

      LoginService.postLogin(idGroup, idEmpresa, contrasenia, correo)
        .then(resp => {
          sessionStorage.setItem('user', JSON.stringify(resp.data.payload));
          sessionStorage.setItem('idUsuario', resp.data.payload.userid);
          if (resp.data.payload.idGroup) {
            sessionStorage.setItem('idGroup', resp.data.payload.idGroup);
          }

          const _user = resp.data.payload;
          if (resp && resp.status !== 500) {

            if (resp.data.payload.isPasswordChangeRequiredOnFirstLogin) {
              EventBus.$emit('modal', false);
            } else {
              const allowedScreens = resp.data.payload.listAllowedScreens.map(screen => screen.screen);
              sessionStorage.setItem('allowedScreens', JSON.stringify(allowedScreens));
              const bucket = resp.data.payload.bucket;
              sessionStorage.setItem('bucket', bucket);
              commit(SET_USER, _user);
              
              if(resp.data.payload.termsConditionsAccepted){
                router.push({
                  name: 'home',
                  params: {
                    _user
                  }
                }).then(() => {
                  window.location.reload();
                });
              } else {
                EventBus.$emit('TyC', resp.data.payload.termsConditionsAccepted)
              }

              resolve(resp)
            }
          }

        })
        .catch(err => {
          sessionStorage.removeItem('token');
          reject(err)
        })
    })
  },

  [ACTION_UPDATE_PASSWORD]: ({ commit }, payload) => {

    return new Promise((resolve, reject) => {
      const idGroup = sessionStorage.getItem("idGroup");
      const idEmpresa = sessionStorage.getItem("idEmpresa");
      const userId = sessionStorage.getItem("idUsuario")
      const firstPassword = btoa(payload.password);
      const secondPassword = btoa(payload.confirmationPassword);
      const forgottenPassword = payload.forgottenPass;

      PasswordService.postPassword(idGroup, idEmpresa, userId, firstPassword, secondPassword, forgottenPassword)
        .then(async resp => {
          sessionStorage.setItem('user', JSON.stringify(resp.data.payload));
          sessionStorage.setItem('idUsuario', resp.data.payload.userid);

          const _user = resp.data;
          commit(SET_USER, _user);

          await Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: i18n.t('login.actionUpdatePassword.label.title'),
            showConfirmButton: false,
            timer: 2500
          });
          EventBus.$emit('clear');
          resolve(resp);
          sessionStorage.clear()
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  [ACTION_GET_TERMS_CONDITIONS]: ({ commit }) => {
    return new Promise((resolve, reject) => {

      const idGroup = sessionStorage.getItem("idGroup");
      const idEmpresa = sessionStorage.getItem("idEmpresa");
      const idUsuario = sessionStorage.getItem("idUsuario");

      LoginService.getTermsConditions(idGroup, idEmpresa, idUsuario)
        .then(resp => {
          commit(SET_TERMS_CONDITIONS, resp.data.payload);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  
  [ACTION_POST_TERMS_CONDITIONS]: ({ commit }) => {
    return new Promise((resolve, reject) => {

      const idGroup = sessionStorage.getItem("idGroup");
      const idEmpresa = sessionStorage.getItem("idEmpresa");
      const idUsuario = sessionStorage.getItem("idUsuario");

      LoginService.postTermsConditions(idGroup, idEmpresa, idUsuario)
        .then(resp => {
          commit(SET_TERMS_CONDITIONS, resp.data.payload);
          router.push({
            name: 'home'
          }).then(() => {
            window.location.reload();
          });
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

}

export default actions;